import { render, staticRenderFns } from "./SideBarModal.vue?vue&type=template&id=f60c8682&scoped=true"
import script from "./SideBarModal.vue?vue&type=script&lang=js"
export * from "./SideBarModal.vue?vue&type=script&lang=js"
import style0 from "./SideBarModal.vue?vue&type=style&index=0&id=f60c8682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60c8682",
  null
  
)

export default component.exports